import React, { useEffect } from 'react';
import styles from './TicketResolution.module.css';

const TicketResolution = () => {
    useEffect(() => {
        document.title = 'Toxbox AI Ticket Resolution';
    }, []);

    return (
        <div className={styles.container}>
            {/* Hero Section */}
            <section className={styles.hero}>
                <div className={styles.heroBackground}></div>
                <h1 className={styles.heroTitle}>Instant AI-Powered Ticket Resolution</h1>
                <p className={styles.heroText}>
                    Streamline your support with Toxbox AI’s intelligent automation for faster resolutions and happier customers.
                </p>
                <div className={styles.ctaButtons}>
                    <button className={styles.primaryButton}>Get Started</button>
                    <button className={styles.secondaryButton}>Request a Demo</button>
                </div>
            </section>

            {/* Why Choose Toxbox AI */}
            <section className={`${styles.section} ${styles.whyChoose}`}>
                <h2 className={styles.sectionTitle}>Why Toxbox AI?</h2>
                <div className={styles.cardContainer}>
                    <div className={styles.card}>
                        <img src="https://images.unsplash.com/photo-1499750310107-5fef28a66643?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Instant Assignment" className={styles.cardImage} />
                        <h3>Instant Assignment</h3>
                        <p>Tickets are auto-assigned to the right agent or department.</p>
                    </div>
                    <div className={styles.card}>
                        <img src="https://images.unsplash.com/photo-1606812667169-0e1991ed3742?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Smart Prioritization" className={styles.cardImage} />
                        <h3>Smart Prioritization</h3>
                        <p>AI identifies and prioritizes urgent issues in real time.</p>
                    </div>
                    <div className={styles.card}>
                        <img src="https://images.unsplash.com/photo-1551497433-e4dfc3cf8b48?q=80&w=1167&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="24/7 Availability" className={styles.cardImage} />
                        <h3>24/7 Availability</h3>
                        <p>Resolve tickets anytime, even outside business hours.</p>
                    </div>
                    <div className={styles.card}>
                        <img src="https://plus.unsplash.com/premium_photo-1682310093719-443b6fe140e8?q=80&w=1212&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Error-Free Routing" className={styles.cardImage} />
                        <h3>Error-Free Routing</h3>
                        <p>Automated routing ensures precision and efficiency.</p>
                    </div>
                </div>
            </section>

            {/* Key Features */}
            <section className={styles.section}>
                <h2 className={styles.sectionTitle}>Key Features</h2>
                <div className={styles.cardContainer}>
                    <div className={styles.card}>
                        <img src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=1170&auto=format&fit=crop" alt="Auto Ticket Logging" className={styles.cardImage} />
                        <h3>Auto Ticket Logging</h3>
                        <p>Capture tickets from Web, Email, Social Media, and WhatsApp.</p>
                    </div>
                    <div className={styles.card}>
                        <img src="https://images.unsplash.com/photo-1516321497487-e288fb19713f?q=80&w=1170&auto=format&fit=crop" alt="Smart Categorization" className={styles.cardImage} />
                        <h3>Smart Categorization</h3>
                        <p>AI analyzes and tags ticket content automatically.</p>
                    </div>
                    <div className={styles.card}>
                        <img src="https://plus.unsplash.com/premium_photo-1705010649877-f561dd47dee9?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Auto-Prioritization" className={styles.cardImage} />
                        <h3>Auto-Prioritization</h3>
                        <p>Flags critical tickets for immediate action.</p>
                    </div>
                    <div className={styles.card}>
                        <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=1170&auto=format&fit=crop" alt="Seamless Escalation" className={styles.cardImage} />
                        <h3>Seamless Escalation</h3>
                        <p>Complex tickets handed off to human agents smoothly.</p>
                    </div>
                </div>
            </section>

            {/* How It Works */}
            <section className={`${styles.section} ${styles.howItWorks}`}>
                <h2 className={styles.sectionTitle}>How It Works</h2>
                <div className={styles.stepContainer}>
                    <div className={styles.step}>
                        <span className={styles.stepNumber}>1</span>
                        <p>Customer submits a ticket via any channel.</p>
                    </div>
                    <div className={styles.step}>
                        <span className={styles.stepNumber}>2</span>
                        <p>AI assesses urgency and category instantly.</p>
                    </div>
                    <div className={styles.step}>
                        <span className={styles.stepNumber}>3</span>
                        <p>Ticket is assigned or resolved automatically.</p>
                    </div>
                    <div className={styles.step}>
                        <span className={styles.stepNumber}>4</span>
                        <p>Real-time updates sent to customers.</p>
                    </div>
                </div>
            </section>

            {/* Call to Action */}
            <section className={styles.callToAction}>
                <h2 className={styles.sectionTitle}>Ready to Transform Your Support?</h2>
                <p className={styles.heroText}>Save time, reduce costs, and delight customers with Toxbox AI.</p>
                <div className={styles.ctaButtons}>
                    <button className={styles.primaryButton}>Schedule a Demo</button>
                    <button className={styles.secondaryButton}>Contact Us</button>
                </div>
            </section>

        </div>
    );
};

export default TicketResolution;